import { render, staticRenderFns } from "./HeaderSet.vue?vue&type=template&id=30ca4549&scoped=true&"
import script from "./HeaderSet.vue?vue&type=script&lang=ts&"
export * from "./HeaderSet.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderSet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HeaderSet.vue?vue&type=style&index=1&id=30ca4549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca4549",
  null
  
)

export default component.exports